<template>
    <div class="dwyc">
        <el-row class="sjyc-block" type="flex" align="middle">
            <el-row>
                <el-select v-model="field" size="small" style="width: 100px">
                    <el-option v-for="item in fieldList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-input v-model="keywords" size="small" style="width: 220px" :placeholder="$tx('clgl.tjbb.sjyc.contentEnter', '请输入内容')" />
                <el-button v-pageBtn-lbl="'search'" size="mini" @click="getData">查询</el-button>
            </el-row>
        </el-row>
        <div>
            <data-table :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="toolbarBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'tjbb',
            moduleInfo: {
                listDataUrl: '/clgl/vwSjxxStatistics/listdata'
            },
            field: 'driverName',
            keywords: '',
            fieldList: [
                {
                    value: 'driverName',
                    label: this.$tx('clgl.tjbb.fields.driverName', '姓名')
                },
                {
                    value: 'driverPhone',
                    label: this.$tx('clgl.tjbb.fields.driverPhone', '电话')
                },
                {
                    value: 'driverNumber',
                    label: this.$tx('clgl.tjbb.fields.driverNumber', '驾驶证号')
                }
            ],
            tbColumns: [
                {
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    width: '45px',
                    title: '序号'
                },
                {
                    listAdvSearchElement: 'input',
                    field: 'driverName',
                    title: '姓名',
                    width: '80px',
                    align: 'left'
                },
                {
                    listAdvSearchElement: 'input',
                    field: 'driverPhone',
                    title: '电话',
                    width: '110px',
                    align: 'left'
                },
                {
                    listAdvSearchElement: 'input',
                    field: 'driverNumber',
                    title: '驾驶证号',
                    align: 'left'
                },
                {
                    listAdvSearchElement: 'input',
                    field: 'drivingAge',
                    title: '司机驾龄',
                    width: '100px',
                    align: 'left'
                },
                {
                    listAdvSearchElement: 'select',
                    field: 'driverType',
                    title: '驾驶证类别',
                    width: '150px',
                    align: 'left',
                    elementFormatter: 'A1：A1、大型客车\r\nA2：A2、牵引车\r\nA3：A3、城市公交车\r\nB1：B1、中型客车\r\nB2：B2、大型货车\r\nC1：C1、小型汽车\r\nC2：C2、小型自动挡汽车\r\nC3：C3、低速载货汽车'
                },
                {
                    listAdvSearchElement: 'input',
                    field: 'drivingNum',
                    title: '出车次数',
                    width: '80px',
                    align: 'center'
                }
            ],
            toolbarBtns: [
                {
                    btnName: '导出',
                    btnIcon: 'export.svg',
                    btnClick: 'exportWfDefines();',
                    btnPermission: 'exportWfDefines',
                    id: 'btn_btn5',
                    btnType: 'toolbar'
                }
            ]
        }
    },
    beforeDestroy() {
        if (document.querySelector('.dwyc')) {
            document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'block'
        }
    },
    mounted() {
        if (document.querySelector('.dwyc')) {
            document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'none'
        }
    },
    methods: {
        getData() {
            this.$bus.emit('refreshListData')
        },
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad($scope, qparams) {
            if (qparams.searchMap) {
                for (var key in qparams.searchMap) {
                    delete qparams.searchMap[key]
                }
            }
            qparams.searchMap[this.field] = this.keywords
            console.log('role listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded($scope, pageInfo) {
            console.log('role listdata loaded')
        }
    }
}
</script>

<style scoped lang="scss">
.dwyc {
    padding: 20px;
    position: relative;
    .sjyc-block {
        position: absolute;
        z-index: 100;
    }
}
</style>
